import type { GalleryListOptions } from '../../types/gallery';
import type { GalleryPageSize } from '../../types/userConfig';

export const GALLERY_SEARCH_DEBOUNCE_MS = 500;
export const GALLERY_SEARCH_MIN_LENGTH = 3;

export type GallerySearchState = {
  debouncedQuery: string;
};

export const DEFAULT_GALLERY_SEARCH: GallerySearchState = {
  debouncedQuery: '',
};

export function buildGalleryListOptions(
  search: GallerySearchState,
  page: number,
  pageSize: GalleryPageSize,
): GalleryListOptions {
  const options: GalleryListOptions = {
    limit: pageSize,
    offset: (page - 1) * pageSize,
  };

  if (search.debouncedQuery.length >= GALLERY_SEARCH_MIN_LENGTH) {
    options.query = search.debouncedQuery;
  }

  return options;
}

export function parseGalleryPageFromSearchParams(
  searchParams: URLSearchParams,
): number {
  const rawPage = Number(searchParams.get('page') ?? '1');
  if (!Number.isFinite(rawPage) || rawPage < 1) {
    return 1;
  }

  return Math.floor(rawPage);
}

export function buildGallerySearchParams({
  page,
  searchInput,
}: {
  page: number;
  searchInput: string;
}): URLSearchParams {
  const params = new URLSearchParams();

  const trimmedSearch = searchInput.trim();
  if (trimmedSearch !== '') {
    params.set('search', trimmedSearch);
  }

  if (page > 1) {
    params.set('page', String(page));
  }

  return params;
}
